import React, { useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import Element from './Element'
import { RxCross2 } from 'react-icons/rx'
import { LiaEdit } from "react-icons/lia";
import { v4 as uuidv4 } from 'uuid';
import { Button, Modal } from 'react-bootstrap';
import { MdDelete, MdErrorOutline } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { FETCHING_ERROR, getAllForms, updateFormStatus } from '../../Redux/Actions/Actions';
import FormLoader from '../Reusable_Components/FromLoader';
import { convertUTCToLocal, sorting_lists, timeElapsed } from '../Reusable_Components/ReusableFunctions';
import AlertPopUp from '../Reusable_Components/Alert';
import TableComponent from '../Reusable_Components/TableComponent';
import Search from '../Reusable_Components/Search';
import Dropdown from '../Reusable_Components/Dropdown';

export default function FormsList({ handleSetActiveTab }) {

    const dispatch = useDispatch()
    const formsList = useSelector((state) => state.formsList)
    const loading = useSelector((state) => state.loading)
    const fetchingError = useSelector((state) => state.fetchingError)

    const [forms, setForms] = useState([])
    const [preview, setPreview] = useState(false)
    const [previewData, setPreviewData] = useState({})
    const [formData, setFormData] = useState({})
    const [useForm, setUseForm] = useState(false)
    const [formId, setFormId] = useState({})
    const [showModal, setShowModal] = useState(false)
    const [currentTime, setCurrentTime] = useState(new Date())
    const [footerValues, setFooterValues] = useState({})
    const [searchText, setSearchText] = useState("")
    const [statusToggleTarget, setStatusToggleTarget] = useState(null)
    const [statusFilter, setStatusFilter] = useState("active")

    const currentFilterCondition = useMemo(() => {
        if (statusFilter === "active") return { is_active: 1 }
        if (statusFilter === "inactive") return { is_active: 0 }
        return null
    }, [statusFilter])

    useEffect(() => {
        dispatch(getAllForms(currentFilterCondition))
    }, [currentFilterCondition])

    const handleFormData = (key, value) => {
        let newFormData = formData
        newFormData[key] = value
        setFormData({ ...newFormData })
    }

    const tableData = (key, row, tableName, value) => {
        let newFormData = { ...formData }
        let tableData = newFormData[tableName] ? newFormData[tableName] : []
        tableData[row] = { ...tableData[row], [key]: value }
        // tableData[row][key] = value
        newFormData[tableName] = tableData

        setFormData(newFormData)
    }

    const handleSaveUsedForm = () => {
        let obj = {
            ...formId,
            entryId: uuidv4(),
            formData: formData,
            time: new Date()
        }
        const usedForms = JSON.parse(localStorage.getItem("Used Forms"))
        const newItems = usedForms ? [...usedForms, obj] : [obj]
        localStorage.setItem('Used Forms', JSON.stringify(newItems));
        setUseForm(false)
        setFormData({})
        setFormId({})
        handleSetActiveTab("Filled Forms")
        setShowModal(false)
    }

    const handleDeleteElement = (id) => {
        const forms = JSON.parse(localStorage.getItem("Forms"))
        const filteredFields = forms.filter((form) => form.id !== id)
        setForms(filteredFields)
        localStorage.setItem("Forms", JSON.stringify(filteredFields))
        // setShowModal(false)
    }

    useEffect(() => {
        const enriched = (formsList || []).map(form => {
            let orientation = "portrait"
            try {
                if (form?.json_data) {
                    const parsed = typeof form.json_data === "string" ? JSON.parse(form.json_data) : form.json_data
                    if (parsed && !Array.isArray(parsed) && parsed.orientation) {
                        orientation = parsed.orientation === "landscape" ? "landscape" : "portrait"
                    }
                }
            } catch (e) {
                // fall through, default portrait
            }
            const label = orientation.charAt(0).toUpperCase() + orientation.slice(1)
            return { ...form, orientation, orientation_label: label }
        })
        setForms(sorting_lists(enriched))
    }, [formsList])

    const handleEnable = (each) => {
        return false;
    }
    return (
        <div>
            <div className='d-flex justify-content-between'>
                <h3>Forms</h3>
                <div className='d-flex align-items-center gap-2 my-2'>
                    <Search
                        value={searchText}
                        handleSearch={(e) => {
                            setSearchText(e.target.value)
                            const filteredData = formsList.filter((form) => form.form_name.toLowerCase().includes(e.target.value.toLowerCase()))
                            setForms(filteredData)
                        }
                        }
                    />
                    <Dropdown
                        selectedOption={statusFilter}
                        handleChange={(e) => setStatusFilter(e.target.value)}
                        options={[
                            { name: "All", value: "all" },
                            { name: "Active", value: "active" },
                            { name: "Inactive", value: "inactive" }
                        ]}
                        className='dropdown-list'
                    />
                    <Link to={'/form/forms'}>
                        <button className='invoice_btn '>Create new form</button>
                    </Link>
                </div>
            </div>
            <TableComponent
                headers={[
                    {
                        name: "Form Name",
                        type: "text",
                        key: "form_name"
                    }, {
                        name: "Form Type",
                        type: "text",
                        key: "form_type"
                    }, {
                        name: "Description",
                        type: "text",
                        key: "description"
                    }, {
                        name: "Created By",
                        type: "text",
                        key: "created_by",
                    }, {
                        name: "Created",
                        type: "time_stamp",
                        key: "created_at",
                        sort: true
                    },
                    {
                        name: "Orientation",
                        type: "text",
                        key: "orientation_label"
                    },
                    {
                        name: "Status",
                        type: "status",
                        key: "is_active"
                    },
                    {
                        name: "Action",
                        type: "button",
                        buttons: [{
                            name: "View",
                            icon: "./images/icons/ViewViewIconEye.svg",
                            disable: handleEnable,
                            action: (data) => {
                                setPreview(true)
                                const parsed = JSON.parse(data?.json_data)
                                const items = Array.isArray(parsed) ? parsed : parsed.items
                                const orientation = Array.isArray(parsed) ? "portrait" : (parsed.orientation || "portrait")
                                setPreviewData({ items, orientation })
                                setFooterValues({
                                    createdAt: data?.created_at,
                                    createdBy: data.created_by,
                                })
                            }
                        },
                        {
                            name: "Edit Status",
                            icon: "./images/icons/Edit.svg",
                            disable: handleEnable,
                            action: (row) => setStatusToggleTarget(row)
                        }]
                    }
                ]}
                data={forms}
            />
            {preview && (() => {
                const isLandscape = previewData?.orientation === "landscape"
                const pageW = isLandscape ? "297mm" : "210mm"
                const pageH = isLandscape ? "210mm" : "297mm"
                return (
                    <div className='form_preview_container' style={{ overflow: 'auto', alignItems: 'flex-start', padding: '20px 0' }}>
                        <style>{`@page { size: A4 ${isLandscape ? "landscape" : "portrait"}; margin: 5mm; }`}</style>
                        <div className='form_view a4-paper' style={{
                            width: pageW,
                            maxWidth: pageW,
                            minHeight: pageH,
                            height: 'auto',
                            padding: '5mm',
                            boxSizing: 'border-box',
                            backgroundColor: 'white',
                            boxShadow: '0 4px 16px rgba(0,0,0,0.25)',
                            // backgroundImage: `repeating-linear-gradient(to bottom, transparent 0, transparent calc(${pageH} - 1px), rgba(0,0,0,0.18) calc(${pageH} - 1px), rgba(0,0,0,0.18) ${pageH})`,
                        }}>
                            <RxCross2 className='close-form' onClick={() => setPreview(false)} />
                            {previewData?.items?.map((previewObj, index) => {
                                return <div key={previewObj.id} id={previewObj.id + " " + index} className='d-flex' style={{ pageBreakInside: 'avoid', breakInside: 'avoid' }}>
                                    {previewObj.items.map((item, index) => {
                                        return <Element preview={true} key={index} object={item} />
                                    })}
                                </div>
                            })}
                            <div className='d-flex justify-content-between flex-wrap mt-3 p-2' style={{ fontSize: "10px", borderTop: "1px solid gray", pageBreakInside: 'avoid', breakInside: 'avoid' }}>
                                <span><b>Created :</b> {convertUTCToLocal(footerValues?.createdAt)}</span>
                                <span><b>Created by :</b> {footerValues?.createdBy}</span>
                            </div>
                        </div>
                    </div>
                )
            })()}
            {useForm && (() => {
                const isLandscape = previewData?.orientation === "landscape"
                const pageW = isLandscape ? "297mm" : "210mm"
                const pageH = isLandscape ? "210mm" : "297mm"
                return (
                    <div className='form_preview_container' style={{ overflow: 'auto', alignItems: 'flex-start', padding: '20px 0' }}>
                        <style>{`@page { size: A4 ${isLandscape ? "landscape" : "portrait"}; margin: 5mm; }`}</style>
                        <div className='form_view a4-paper' style={{
                            width: pageW,
                            maxWidth: pageW,
                            minHeight: pageH,
                            height: 'auto',
                            padding: '5mm',
                            boxSizing: 'border-box',
                            backgroundColor: 'white',
                            boxShadow: '0 4px 16px rgba(0,0,0,0.25)',
                            // backgroundImage: `repeating-linear-gradient(to bottom, transparent 0, transparent calc(${pageH} - 1px), rgba(0,0,0,0.18) calc(${pageH} - 1px), rgba(0,0,0,0.18) ${pageH})`,
                        }}>
                            <RxCross2 className='close-form' onClick={() => {
                                setUseForm(false)
                                setFormData({})
                            }} />
                            {previewData?.items?.map((previewObj, index) => {
                                return <div key={previewObj?.id} id={previewObj?.id + " " + index} className='d-flex' style={{ pageBreakInside: 'avoid', breakInside: 'avoid' }}>
                                    {previewObj?.items?.map((item, i) => {
                                        return <Element preview={true} key={i} object={item} handleFormData={handleFormData} rowIndex={index} colIndex={i} tableData={tableData} formUse={true} />
                                    })}
                                </div>
                            })}
                        </div>
                        <div style={{ backgroundColor: "white", height: "90%", width: "25%" }}>
                        <div style={{ height: "90%", overflow: "auto" }}>
                            {
                                formData && <pre style={{ textWrap: "wrap" }}>{JSON.stringify(formData, null, 2)}</pre>
                            }
                        </div>
                        <div style={{ height: "10%" }} className='d-flex justify-content-end align-items-center p-2'>
                            <button className='btn btn-primary' onClick={() => setShowModal(true)}>Save</button>
                        </div>
                    </div>
                </div>
                )
            })()}
            <Modal keyboard={false} backdrop="static" show={showModal} centered onHide={() => setShowModal(false)} style={{ zIndex: "100000000000", backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
                <Modal.Body>Are you sure you have entered all the fields</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleSaveUsedForm}>
                        OK
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal keyboard={false} backdrop="static" show={!!statusToggleTarget} centered onHide={() => setStatusToggleTarget(null)} style={{ zIndex: "100000000000", backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
                <Modal.Body>
                    {statusToggleTarget && (
                        (() => {
                            const isCurrentlyActive = statusToggleTarget.is_active === 1 || statusToggleTarget.is_active === true || statusToggleTarget.is_active === undefined || statusToggleTarget.is_active === null
                            return <span>{isCurrentlyActive ? "Deactivate" : "Activate"} form <b>{statusToggleTarget.form_name}</b>?</span>
                        })()
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        className="btn btn-sm"
                        style={{ background: "#e9ecef", color: "#333", border: "1px solid #ced4da" }}
                        onClick={() => setStatusToggleTarget(null)}
                    >
                        Cancel
                    </button>
                    {statusToggleTarget && (() => {
                        const isCurrentlyActive = statusToggleTarget.is_active === 1 || statusToggleTarget.is_active === true || statusToggleTarget.is_active === undefined || statusToggleTarget.is_active === null
                        const label = isCurrentlyActive ? "Deactivate" : "Activate"
                        return (
                            <button
                                type="button"
                                className="btn btn-sm"
                                style={{ background: "#525252", color: "white", border: "1px solid #525252" }}
                                onClick={() => {
                                    const next = isCurrentlyActive ? 0 : 1
                                    dispatch(updateFormStatus(statusToggleTarget.form_id, next, currentFilterCondition))
                                    setStatusToggleTarget(null)
                                }}
                            >
                                {label}
                            </button>
                        )
                    })()}
                </Modal.Footer>
            </Modal>
            {loading && <FormLoader />}
            {fetchingError && <AlertPopUp
                alertShow={fetchingError}
                alertType="error"
                alertMsg="Error"
                alertValue={fetchingError}
                alertButtons={[{ name: "Close", action: () => { dispatch({ type: FETCHING_ERROR, payload: null }) } }, {
                    name: "Retry", action: () => {
                        dispatch(getAllForms())
                        dispatch({
                            type: FETCHING_ERROR,
                            payload: null
                        })
                    }
                }]}
            />}
        </div>
    )
}
